import React, { useState, useMemo, useEffect } from 'react';
import { useTheme } from 'styled-components';
import { useSelector } from 'react-redux';

import { getCloudinaryPathWithCache, getInitials } from '~/utils';

import { Container, Image, Logo } from './styles';

export default function Brand({ color, variant, ...props }) {
  const theme = useTheme();

  const [imageNotAvailable, setImageNotAvailable] = useState(false);
  const [imageSrc, setImageSrc] = useState('');

  const { title = 'Escola' } = useSelector((state) => state.school.data);

  const brandTitle = useMemo(() => (variant === 'menu' ? getInitials(title, true) : title), [
    title,
    variant,
  ]);

  useEffect(() => {
    const loadImage = async () => {
      try {
        const url = await getCloudinaryPathWithCache(theme.brand[variant || 'default']);
        setImageSrc(url);
      } catch (error) {
        console.warn('Failed to load brand image:', error);
        setImageSrc(theme.brand[variant || 'default']);
      }
    };

    if (theme.brand[variant || 'default']) {
      loadImage();
    }
  }, [theme.brand, variant]);

  return (
    <Container>
      {!imageNotAvailable ? (
        <Image
          {...props}
          variant={variant}
          src={imageSrc}
          onError={() => setImageNotAvailable(true)}
          alt="logo"
        />
      ) : (
        <Logo color={color} variant={variant}>
          <span>{brandTitle}</span>
        </Logo>
      )}
    </Container>
  );
}
